module.exports = new __parcel__URL__("select-airtable-csv.105fe2e2.svg").toString();